import { render, staticRenderFns } from "./CourseTimeRecord.vue?vue&type=template&id=0ca4e990&"
import script from "./CourseTimeRecord.vue?vue&type=script&lang=js&"
export * from "./CourseTimeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports